import React from "react";
import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";

const Loading = () => {
  return (
    <Box flexGrow="1" alignItems="center" justifyContent="center" display="flex">
      <CircularProgress />
    </Box>
  );
};

export default Loading;
